import { IProgress } from "../../components/utils/ProgressBar/ProgressBar";

export const loadComplete = (progress: IProgress) => {
    return progress.currentStep === progress.totalSteps;
}